import * as Rollbar from 'rollbar';

let liveEnvironment: string;
const hostName = window.location.hostname;

switch (hostName) {
  case 'go.winerist.com': {
    liveEnvironment = 'production';
    break;
  }
  case 'partner-winerist-il.azurewebsites.net': {
    liveEnvironment = 'staging';
    break;
  }
  case 'localhost': {
    liveEnvironment = 'development';
    break;
  }
  default: {
    liveEnvironment = 'development';
    break;
  }
}

export const rollbarConfig: Rollbar.Configuration = {
  accessToken: 'dd36d66676114b53ab7823280b7318f7',
  captureUncaught: true,
  captureUnhandledRejections: true,
  environment: liveEnvironment,
  enabled: liveEnvironment === 'production' || liveEnvironment === 'staging',
  host: hostName,
};
